<template>
  <div class="flex items-center">
    <div class="row-image-wrapper" v-if="isImage">
      <img
        :src="imageSrc"
        alt="Logo"
        class="row-image-inner"
      />
    </div>
    <span v-if="params.content">{{ params.content }}</span>
  </div>
</template>

<script>
export default {
  name: 'CellRendererLogo',
  computed: {
    isImage() {
      console.log(this.params)
      // crude check: PNG base64 usually starts with iVBOR
      return typeof this.params.logo === 'string' && this.params.logo.startsWith('iVBOR');
    },
    imageSrc() {
      // If it's an image, return the data URL
      if (this.isImage) {
        return `data:image/png;base64,${this.params.logo}`;
      }
      return '';
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/scss/custom/components/variables';

  .row-image-wrapper {
    width: 100px;
    max-height: 40px;
    margin-right: 10px;
  }

  .row-image-inner {
    max-width: 100px;
    max-height: 40px;
    margin: auto;
    display: block;
  }
</style>
